import { render, staticRenderFns } from "./chart-item.vue?vue&type=template&id=eaa60bb8&scoped=true"
import script from "./chart-item.vue?vue&type=script&lang=js"
export * from "./chart-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa60bb8",
  null
  
)

export default component.exports